import { BecomeAPartnerForm } from "./BecomeAPartnerForm";

export { BecomeAPartnerForm };
